<px-m0180-podcast [image]="image" [links]="_links"></px-m0180-podcast>
